/* Fiocco Nero: the add-to-cart button stays off until the customer picks a size. Working copy only. */
(function () {
  function init(form) {
    var btn = form.querySelector('[data-fn-size-pending]');
    if (!btn || btn.dataset.fnReady) return;
    btn.dataset.fnReady = '1';
    var tpl = form.parentNode.querySelector('template[data-fn-add-to-cart-label]') || document.querySelector('template[data-fn-add-to-cart-label]');
    var scope = form.closest('.ProductMeta, .Product__Wrapper, .Product, [data-section-type="product"]') || document;

    function chosen() {
      if (!btn.hasAttribute('data-fn-size-pending')) return;
      btn.removeAttribute('data-fn-size-pending');
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      btn.classList.remove('Button--secondary');
      btn.classList.add('Button--primary');
      if (tpl && btn.textContent.trim() === 'בחרו מידה') btn.innerHTML = tpl.innerHTML;
    }
    // a size picked in the popover (theme renders the popovers outside the form)
    document.addEventListener('click', function (e) {
      var v = e.target.closest('[data-action="select-value"], .VariantSelector__Item, [data-action="select-variant"]');
      if (!v || v.disabled) return;
      setTimeout(function () {
        chosen();
        // the theme may not refresh the label if the same variant was already active
        var lab = scope.querySelector('.ProductForm__SelectedValue');
        if (lab && lab.textContent.trim() === 'בחרו מידה') lab.textContent = v.getAttribute('data-value') || v.textContent.trim();
      }, 60);
    }, true);
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') chosen(); });
    // clicking the disabled button area opens the size list
    var wrap = btn.parentNode;
    wrap.addEventListener('click', function (e) {
      if (!btn.hasAttribute('data-fn-size-pending')) return;
      if (e.target !== btn && !btn.contains(e.target)) return;
      e.preventDefault();
      var opener = form.querySelector('.ProductForm__Item');
      if (opener) opener.click();
    }, true);
    form.addEventListener('submit', function (e) {
      if (btn.hasAttribute('data-fn-size-pending')) { e.preventDefault(); e.stopImmediatePropagation(); var o = form.querySelector('.ProductForm__Item'); if (o) o.click(); }
    }, true);
  }
  function run() { document.querySelectorAll('form.ProductForm, form[action*="/cart/add"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
